import React from "react";
import { withStyles } from "@material-ui/core";
import { CircularProgress, Checkbox } from "@material-ui/core";
import Scroll from "../../../../../components/InfiniteScroll/Scroll";

const ProfissionalSaudeList = ({
  classes,
  listaModal,
  handleChangeCheckbox,
  loadMore,
  lastScroll,
  loadingModal,
}) => {
  return (
    <div className={classes.content}>
      <Scroll
        loadMore={loadMore}
        hasMore={!lastScroll}
        pageStart={0}
        initialLoad={false}
        className={classes.scrollContainerModelos}
      >
        <div className={classes.titles}>
          <div className={classes.title}> Selecione o Profisional </div>
        </div>
        {listaModal.length > 0 &&
          listaModal.map((itemLista, index) => (
            <div className={classes.linha} key={index}>
                <Checkbox
                  id={`cfg-psl-chk-prf-${index}`}
                  color={"primary"}
                  onChange={() => handleChangeCheckbox(itemLista, index)}
                  checked={itemLista.profissionaisSaude?.checked}
                />
                <div className={classes.procedimento}>
                  {itemLista.profissionaisSaude?.nome}
                </div>
            </div>
          ))}
        {loadingModal && (
          <div className={classes.contentLoading}>
            <CircularProgress />
          </div>
        )}
      </Scroll>
    </div>
  );
};

const styles = {
  content: {
    height: "calc(100% - 105px)",
    overflow: "auto",
  },
  titles: {
    display: "flex",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 1,
    background: "#fff",
  },
  title: {
    fontSize: "10px",
    color: "#868686",
  },
  procedimento: {
    color: "#868686",
  },
  linha: {
    display: "flex",
    alignItems: "center",
    marginBottom: "4px",
    height: "40px",
  },
  contentLoading: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  scrollContainerModelos: {
    height: "100%",
  },
};

export default withStyles(styles)(ProfissionalSaudeList);
